import {Box} from '@mantine/core';
import React from 'react';

import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ExperimentalInputs} from 'procedures/planning/ProcedurePlanTypes';
import {TransposedReplicateTableSection} from 'studies/typed/shared/procedure-runs/conditions/TransposedReplicateTableSection';
import {ConditionGroup} from 'studies/typed/shared/procedure-runs/design-state/useExperimentDesignState';
import MethodExecutionLimitError from 'studies/typed/shared/procedure-runs/execution-status/MethodExecutionLimitError';
import {MethodExecutionLimitState} from 'studies/typed/shared/procedure-runs/execution-status/useMethodExecutionLimitState';

export interface ConditionsSectionProps {
  isPlan: boolean;
  conditions: Array<ConditionGroup>;
  setConditions: (conditions: Array<ConditionGroup>, prevIndexes: Array<number | null>) => void;
  experimentalInputs: ExperimentalInputs;
  setExperimentalInputs: (experimentalInputs: ExperimentalInputs) => void;
  editNumColsButtons: JSX.Element;
  locked: boolean;
  methodExecutionLimitState: MethodExecutionLimitState;
  procedureType: ProcedureType;
  newConditionCoveredMethodIds?: ReadonlyArray<string>;
  archivedDisplay?: {showArchived: boolean; pendingRemovedByConditionIndex: ReadonlyMap<number, number>};
  dataTestAttrs?: {[key: string]: string};
}

export default function ConditionsSection(props: ConditionsSectionProps): JSX.Element {
  return (
    <>
      <TransposedReplicateTableSection
        conditions={props.conditions}
        setConditions={props.setConditions}
        archivedDisplay={props.archivedDisplay}
        experimentalInputs={props.experimentalInputs}
        setExperimentalInputs={props.setExperimentalInputs}
        editNumColsButtons={props.editNumColsButtons}
        locked={props.locked}
        procedureType={props.procedureType}
        newConditionCoveredMethodIds={props.newConditionCoveredMethodIds}
        isPlan={props.isPlan}
        dataTestAttrs={props.dataTestAttrs}
      />
      {props.methodExecutionLimitState.isOverLimit && (
        <Box mt="md">
          <MethodExecutionLimitError
            replicateLimit={props.methodExecutionLimitState.replicateLimit}
            procedureType={props.procedureType}
          />
        </Box>
      )}
    </>
  );
}
